// Based on the passed in comma-separated list of identifyFields we only return those specified + sort  in the order they were passed in.
export const filterAndSortFields = (fields: Array<any>, fieldsToInclude: Array<string>): Array<object> => {
  return fields.filter(field => {
    return fieldsToInclude.includes(field.id)
  }).sort((a, b) => {
    return fieldsToInclude.indexOf(a.id) - fieldsToInclude.indexOf(b.id)
  })
}
